/**
 * @description: 电视屏广告位置设置
 * @author: hwx
 * @update: lyr
 * @update: wgt
 * @update: chy
 */
<template>
	<div class="ad-space-set">
		<div class="adsc-list" v-show="showList">
			<h1>电视屏广告位置设置</h1>
			<el-form :inline="true">
				<el-form-item label="门店">
					<el-select v-model="shop_id" filterable clearable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="getListTable">查询</el-button>
				<el-button type="primary" @click="syncData">同步</el-button>
			</el-form>
			<!-- <el-button type="primary" @click="adscAdd">新增图片</el-button> -->
			<el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)" :data="list_table">
				<el-table-column prop="name" label="功能模块"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">{{scope.row.status == '1' ? '启用' : '禁用'}}</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="onEditClick(scope.row)">修改</span>
						<span class="text-blue" @click="setStatus(scope.row)">{{scope.row.status == '-1' ? '启用' :
							'禁用'}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 互动广场 -->
		<div class="hdgc-panel" v-show="showHdgc">
			<h2>互动广场</h2>
			<div class="red-tip">注：图片格式均为png，如您上传图片不符合规格，将不能显示或被压缩</div>
			<h4>单屏模式</h4>
			<div class="gray-block">
				<div class="row">
					<div class="label">图片轮播间隔</div>
					<el-input placeholder="请输入时长" v-model="jhPlazaAd.time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：多张图片时每个图片切换的时间间隔</div>
				</div>
				<div class="row">
					<div class="label">图片（{{jhPlazaAd.imgs.length}}/10张）</div>
					<div class="red-tip">注：图片尺寸527*296</div>
				</div>
				<div class="imgs-wrapper">
					<div class="item single" v-for="(item,index) in jhPlazaAd.imgs" :id="'singleImg-'+index">
						<img :src="item" alt="" class="img" v-if="item!=''">
						<img src="../../assets/images/adsc_up.png" alt="" class="img" v-else>
						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon"
							@click.stop="delThisImg('single', index)">
					</div>
					<div class="item single" v-show="jhPlazaAd.imgs.length<10" @click="onAddImgClick('single')">
						<img src="../../assets/images/adsc_up.png" alt="" class="img">
					</div>
				</div>
			</div>
			<h4>四联屏模式-互动屏</h4>
			<div class="gray-block">
				<div class="row">
					<div class="label big">聊天内容位置</div>
					<div class="red-tip">注：聊天窗内容根据设置推送广告图片显示</div>
					<el-button type="primary" size="small" style="margin-left:10px;"
						@click="openAvatarPop">头像及昵称设置</el-button>
				</div>
				<div class="row">
					<div class="label">每隔多久显示</div>
					<el-input placeholder="请输入时长" v-model="jhPlazaAd.multiple_screens_chat_time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：进入互动广场每隔多久显示一次图片，多张图时随机显示其中一张</div>
				</div>
				<div class="row">
					<div class="label">图片（{{jhPlazaAd.multiple_screens_chat_imgs.length}}/10张）</div>
					<div class="red-tip">注：图片尺寸648*240</div>
				</div>
				<div class="imgs-wrapper">
					<div class="item chat" v-for="(item,index) in jhPlazaAd.multiple_screens_chat_imgs"
						:id="'chatImg-'+index">
						<img :src="item" alt="" class="img" v-if="item!=''">
						<img src="../../assets/images/upl_648_240.png" alt="" class="img" v-else>
						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon"
							@click.stop="delThisImg('chat', index)">
					</div>
					<div class="item chat" v-show="jhPlazaAd.multiple_screens_chat_imgs.length<10"
						@click="onAddImgClick('chat')">
						<img src="../../assets/images/upl_648_240.png" alt="" class="img">
					</div>
				</div>
				<div class="row">
					<div class="label big">底部固定位置</div>
				</div>
				<div class="row">
					<div class="label">图片轮播间隔</div>
					<el-input placeholder="请输入时长" v-model="jhPlazaAd.multiple_screens_bottom_time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：多张图片时每个图片切换的时间间隔</div>
				</div>
				<div class="row">
					<div class="label">图片（{{jhPlazaAd.multiple_screens_bottom_imgs.length}}/10张）</div>
					<div class="red-tip">注：图片尺寸880*210</div>
				</div>
				<div class="imgs-wrapper">
					<div class="item bottom" v-for="(item,index) in jhPlazaAd.multiple_screens_bottom_imgs"
						:id="'bottomImg-'+index">
						<img :src="item" alt="" class="img" v-if="item!=''">
						<img src="../../assets/images/upl_880_210.png" alt="" class="img" v-else>
						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon"
							@click.stop="delThisImg('bottom', index)">
					</div>
					<div class="item bottom" v-show="jhPlazaAd.multiple_screens_bottom_imgs.length<10"
						@click="onAddImgClick('bottom')">
						<img src="../../assets/images/upl_880_210.png" alt="" class="img">
					</div>
				</div>
			</div>
			<div class="btns">
				<el-button @click="backList">取消</el-button>
				<el-button type="primary" @click="submitHdgc">确认</el-button>
			</div>
			<!-- 头像设置弹窗 -->
			<div class="avatar-set-pop ele-hide" ref="avatar_set_pop">
				<el-form>
					<el-form-item label="昵称">
						<el-input placeholder="请输入昵称" v-model="jhPlazaAd.virtual_user_name"></el-input>
					</el-form-item>
					<el-form-item label="头像">
						<div class="avatar-wrapper">
							<img class="avatar-img" :src="jhPlazaAd.virtual_user_img"></img>
							<el-button type="primary" size="small" id="changeAvatarBtn">更换头像</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<!-- 语音点歌 -->
		<div class="yydg-panel" v-show="showYydg">
			<h2>语音点歌</h2>
			<div class="red-tip">注：图片格式均为png，如您上传图片不符合规格，将不能显示或被压缩</div>
			<h4>四联屏模式-互动屏</h4>
			<div class="gray-block">
				<div class="row">
					<div class="label big">顶部固定位置</div>
					<div class="red-tip">注：语音点歌窗弹窗顶部位置</div>
				</div>
				<div class="row">
					<div class="label">图片（{{chooseSongAd.multiple_screens_top_imgs.length}}/10张）</div>
					<div class="red-tip">注：图片尺寸880*210</div>
				</div>
				<div class="row">
					<div class="red-tip">注：多张图时随机显示其中一张</div>
				</div>
				<div class="imgs-wrapper">
					<div class="item bottom" v-for="(item,index) in chooseSongAd.multiple_screens_top_imgs"
						:id="'topImg-'+index">
						<img :src="item" alt="" class="img" v-if="item!=''">
						<img src="../../assets/images/upl_880_210.png" alt="" class="img" v-else>
						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon"
							@click.stop="delThisImg('top', index)">
					</div>
					<div class="item bottom" v-show="chooseSongAd.multiple_screens_top_imgs.length<10"
						@click="onAddImgClick('top')">
						<img src="../../assets/images/upl_880_210.png" alt="" class="img">
					</div>
				</div>
			</div>
			<div class="btns">
				<el-button @click="backList">取消</el-button>
				<el-button type="primary" @click="submitYydg">确认</el-button>
			</div>
		</div>

		<!-- 电视屏保 -->
		<div class="dspb-panel" v-show="showDspb">
			<h2>电视屏保</h2>
			<div class="red-tip">注：图片格式均为png，如您上传图片不符合规格，将不能显示或被压缩</div>
			<h4>四联屏模式-互动屏</h4>
			<div class="gray-block">
				<div class="row">
					<el-radio v-model="screenSaverAd.type" label="1">全屏模式</el-radio>
					<el-radio v-model="screenSaverAd.type" label="2">弹窗模式</el-radio>
					<div class="red-tip">注：全屏模式则互动屏满屏显示图片；弹窗模式则互动屏中间部分显示图片</div>
				</div>
				<div class="row">
					<div class="label">每隔多久显示</div>
					<el-input placeholder="请输入时长" v-model="screenSaverAd.multiple_screens_play_time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：互动屏每隔多久进入一次屏保</div>
				</div>
				<div class="row">
					<div class="label">每次显示多久</div>
					<el-input placeholder="请输入时长" v-model="screenSaverAd.multiple_screens_play_time">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：互动屏进入屏保后，显示多久之后消失</div>
				</div>
				<div class="row">
					<div class="label">屏保类型</div>
					<el-radio v-model="screenSaverAd.style" label="1">图片</el-radio>
					<el-radio v-model="screenSaverAd.style" label="2">歌曲排行榜单</el-radio>
				</div>
				<div class="row" v-show="screenSaverAd.style == '1'">
					<div class="label">图片轮播间隔</div>
					<el-input placeholder="请输入时长" v-model="screenSaverAd.multiple_screens_img_time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：多张图片时每个图片切换的时间间隔</div>
				</div>
				<div class="row" v-show="screenSaverAd.style == '2'">
					<div class="label">榜单轮播间隔</div>
					<el-input placeholder="请输入时长" v-model="screenSaverAd.multiple_screens_img_time_lag">
						<template slot="append">秒</template>
					</el-input>
					<div class="red-tip">注：多个榜单时每个榜单切换的时间间隔</div>
				</div>
				<div class="row" v-show="screenSaverAd.style == '1'">
					<div class="label">图片（{{screenSaverAd.multiple_screens_imgs.length}}/10张）</div>
					<!-- <div class="red-tip">注：图片尺寸1080*1920</div>screenSaverAd.type -->
					 <div class="red-tip">{{screenSaverAd.type == '1' ? '注：图片尺寸1080*1920' : '注：图片尺寸820x1138'}}</div>
				</div>
				<div class="imgs-wrapper" v-show="screenSaverAd.style == '1'">
					<div class="item screen" v-for="(item,index) in screenSaverAd.multiple_screens_imgs"
						:id="'screenImg-'+index">
						<img :src="item" alt="" class="img" v-if="item!=''">
						<img src="../../assets/images/scrn_img_sp.png" alt="" class="img" v-else>
						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon"
							@click.stop="delThisImg('screen', index)">
					</div>
					<div class="item screen" v-show="screenSaverAd.multiple_screens_imgs.length<10"
						@click="onAddImgClick('screen')">
						<img src="../../assets/images/scrn_img_sp.png" alt="" class="img">
					</div>
				</div>
				<div class="row" v-show="screenSaverAd.style == '2'">
					<div class="label">榜单（{{screenSaverAd.match_data.length}}/10张）</div>
					<el-button type="primary" @click="addRankItem">新增</el-button>
					<div class="red-tip">注：自定义背景图图片尺寸为：1080*1920</div>
				</div>
				<div class="ranks-wrapper" v-show="screenSaverAd.style == '2'">
					<div class="ranks-container">
						<div class="rank-item" v-for="(item, index) in screenSaverAd.match_data" :key="index">
							<div class="rank-content">
								<div class="image-section">
									<div class="image-placeholder" :id="'matchImg-'+index">
										<img v-if="item.img" :src="item.img" alt="背景图" class="background-img">
										<img src="../../assets/images/default_bg.png" alt="" class="background-img"
											v-else>
										<el-button class="change-btn" type="primary" size="mini">更换图片</el-button>
									</div>
								</div>
								<div class="dropdowns-section">
									<el-select v-model="item.match" placeholder="请选择榜单类型" class="rank-dropdown">
										<el-option label="约战赛事榜单" value="1"></el-option>
										<el-option label="K歌榜" value="2"></el-option>
										<el-option label="豪气榜" value="3"></el-option>
										<el-option label="霸屏榜" value="4"></el-option>
										<el-option label="麦霸大赛榜" value="5"></el-option>
									</el-select>
									<el-select v-if="item.match == '5'" v-model="item.group" placeholder="请选择排序方式" class="rank-dropdown">
										<el-option label="按全国" value="1"></el-option>
										<el-option label="按商家" value="2"></el-option>
									</el-select>
									<el-select v-else v-model="item.group" placeholder="请选择排序方式" class="rank-dropdown">
										<el-option label="按商家" value="1"></el-option>
										<el-option label="按门店" value="2"></el-option>
									</el-select>
									<el-select v-model="item.cycle" placeholder="请选择排行周期" class="rank-dropdown">
										<el-option label="月排行" value="1"></el-option>
										<el-option label="周排行" value="2"></el-option>
									</el-select>
								</div>
							</div>
							<div class="close-btn" @click="removeRankItem(index)">
								<i class="el-icon-close"></i>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="btns">
				<el-button @click="backList">取消</el-button>
				<el-button type="primary" @click="submitDspb">确认</el-button>
			</div>
		</div>

		<!-- 同步弹窗 -->
		<div class="sync-pop ele-hide" ref="sync_pop">
			<div class="sync-content">
				<div class="sync-title">将【{{currentShopName}}】电视屏广告设置所有数据同步到其他门店!</div>
				<div class="sync-subtitle">请选择需要同步数据的门店</div>
				<div class="shop-list">
					<div class="shop-item">
						<el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
					</div>
					<div class="shop-grid">
						<div class="shop-item" v-for="shop in shop_list" :key="shop.id" v-if="shop.id != shop_id">
							<el-checkbox v-model="selectedShops" :label="shop.id">{{shop.name}}</el-checkbox>
						</div>
					</div>
				</div>
				<div class="sync-buttons">
					<el-button @click="cancelSync">取消</el-button>
					<el-button type="primary" @click="confirmSync">确认</el-button>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
                loading: false,
                shop_list: [],
                shop_id: '',
                list_table: [],
                
                // 同步相关数据
                selectAll: false,
                selectedShops: [],

				showList: true,
				showHdgc: false,
				showYydg: false,
				showDspb: false,
				jhPlazaAd: {
					shop_id: "",
		            imgs: [], // 单屏模式轮播图
		            time_lag: "", // 图片轮播间隔
		            multiple_screens_chat_imgs: [], // 四联屏模式聊天广告
		            multiple_screens_chat_time_lag: "", // 四联屏模式显示间隔
		            virtual_user_name: "", // 聊天人物昵称
		            virtual_user_img: "", // 聊天人物头像
		            multiple_screens_bottom_imgs: [],// 底部广告图
		            multiple_screens_bottom_time_lag: "" // 底部广告轮播间隔
				},
				singleUploaders: [],
				chatUploaders:[],
				bottomUploaders: [],
				avatarUploaders: [],
				topUploaders: [],
				screenUploaders: [],
                matchUploaders: [],

				chooseSongAd: {
					shop_id: '',
					multiple_screens_top_imgs: []
				},
				screenSaverAd: {
					shop_id: "",
		            type: "1", // 1：全屏模式，2：弹窗模式
		            multiple_screens_play_time_lag: "", // 每隔多久显示
		            multiple_screens_play_time: "", // 每次显示多久
		            multiple_screens_img_time_lag: "", // 图片轮播间隔
		            multiple_screens_imgs: [],
                    match_data:[
                        {
                            id: '',//编辑旧数据时必传
                            match: 1,//榜单类型 默认1:约战赛事榜单
                            group: 1,//分组 1:商家 2:门店
                            cycle: 1,//周期 1:月排行 2:周排行
                            img: "https://vodonline.g-hi.com/test-ktv/uploads/Setting/20221209_6392f308e8e6b.png"//背景图
                        },
                        {
                            id: '',//编辑旧数据时必传
                            match: 1,//榜单类型 默认1:约战赛事榜单
                            group: 1,//分组 1:商家 2:门店
                            cycle: 1,//周期 1:月排行 2:周排行
                            img: "https://vodonline.g-hi.com/test-ktv/uploads/Setting/20221209_6392f308e8e6b.png"//背景图
                        },
                    ] // 榜单数据   
				},
			}
		},
		computed: {
			// 获取当前门店名称
			currentShopName() {
				const currentShop = this.shop_list.find(shop => shop.id == this.shop_id);
				return currentShop ? currentShop.name : '';
			}
		},
		watch: {
			// 监听选中的门店变化，自动更新全选状态
			selectedShops: {
				handler(newVal) {
					const otherShops = this.shop_list.filter(shop => shop.id != this.shop_id);
					this.selectAll = newVal.length === otherShops.length && otherShops.length > 0;
				},
				deep: true
			}
		},
		mounted: function() {
            this.getShop();
		},
		methods: {
            // 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						_this.shop_id = _this.shop_list[0].id
						_this.getListTable()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 列表
			getListTable: function() {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('ScreenAd/getSetting', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.shop_id,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.list_table = res.data.response.result;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 禁用、启用
            setStatus(row) {
                let _this = this;
                let title = row.status == '-1' ? '是否启用？' : '是否禁用？'
				layer.confirm(title, {
					btn: ['确定', '取消'],
					title: '提示'
				}, function() {
					Vue.axios.post('ScreenAd/setStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"shop_id": _this.shop_id,
								"type": row.type
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功！');
							_this.getListTable();
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },

            // 点击"修改"
            onEditClick(row) {
            	if (row.type == 'jh_plaza') { // 互动广场
            		this.getHdgcDetail(this.shop_id)
            		this.showList = false
            		this.showHdgc = true
            	}else if(row.type == 'voice_choose_song') { // 语音点歌
            		this.getYydgDetail(this.shop_id)
            		this.showList = false
            		this.showYydg = true
            	}else if(row.type == 'screensaver') { // 电视屏保
            		this.getDspbDetail(this.shop_id)
            		this.showList = false
            		this.showDspb = true
            	}
            },

            // 获取互动广场配置
            getHdgcDetail(shop_id) {
				const _this = this;

				Vue.axios.post('JhPlazaAd/getDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let detail = JSON.parse(JSON.stringify(res.data.response.result))
						if (Array.isArray(detail)) {
							_this.jhPlazaAd = {
								shop_id: _this.shop_id,
					            imgs: [], // 单屏模式轮播图
					            time_lag: "", // 图片轮播间隔
					            multiple_screens_chat_imgs: [], // 四联屏模式聊天广告
					            multiple_screens_chat_time_lag: "", // 四联屏模式显示间隔
					            virtual_user_name: "", // 聊天人物昵称
					            virtual_user_img: "", // 聊天人物头像
					            multiple_screens_bottom_imgs: [],// 底部广告图
					            multiple_screens_bottom_time_lag: "" // 底部广告轮播间隔
							}
						}else {
							detail.shop_id = _this.shop_id
							_this.jhPlazaAd = detail
						}
						_this.clearAllUploaders()

						if (_this.jhPlazaAd.imgs.length > 0) { // 单屏模式
							_this.jhPlazaAd.imgs.forEach((item, index) => {
								_this.imgUpload('singleImg-' + index, index)
							})
						}
						if (_this.jhPlazaAd.multiple_screens_chat_imgs.length > 0) { // 四联屏聊天
							_this.jhPlazaAd.multiple_screens_chat_imgs.forEach((item, index) => {
								_this.imgUpload('chatImg-' + index, index)
							})
						}
						if (_this.jhPlazaAd.multiple_screens_bottom_imgs.length > 0) { // 四联屏底部
							_this.jhPlazaAd.multiple_screens_bottom_imgs.forEach((item, index) => {
								_this.imgUpload('bottomImg-' + index, index)
							})
						}
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 获取语音点歌配置
            getYydgDetail(shop_id) {
				const _this = this;

				Vue.axios.post('ScreenAd/getVoiceChooseSongAd', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let detail = JSON.parse(JSON.stringify(res.data.response.result))
						if (Array.isArray(detail)) {
							_this.chooseSongAd = {
								shop_id: _this.shop_id,
								multiple_screens_top_imgs: []
							}
						}else {
							detail.shop_id = _this.shop_id
							_this.chooseSongAd = detail
						}
						_this.clearAllUploaders()

						if (_this.chooseSongAd.multiple_screens_top_imgs.length > 0) {
							_this.chooseSongAd.multiple_screens_top_imgs.forEach((item, index) => {
								_this.imgUpload('topImg-' + index, index)
							})
						}
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 获取电视屏保配置
            getDspbDetail(shop_id) {
				const _this = this;

				Vue.axios.post('ScreenAd/getScreensaverAd', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let detail = JSON.parse(JSON.stringify(res.data.response.result))
						if (Array.isArray(detail)) {
							_this.screenSaverAd = {
								shop_id: _this.shop_id,
					            type: "1", // 1：全屏模式，2：弹窗模式
					            multiple_screens_play_time_lag: "", // 每隔多久显示
					            multiple_screens_play_time: "", // 每次显示多久
					            multiple_screens_img_time_lag: "", // 图片轮播间隔
					            multiple_screens_imgs: [],
                                match_data:[]
							}
						}else {
							detail.shop_id = _this.shop_id
							_this.screenSaverAd = detail
						}
						_this.clearAllUploaders()

						if (_this.screenSaverAd.multiple_screens_imgs.length > 0) {
							_this.screenSaverAd.multiple_screens_imgs.forEach((item, index) => {
								_this.imgUpload('screenImg-' + index, index)
							})
						}
                        if(_this.screenSaverAd.match_data.length > 0){
                            _this.screenSaverAd.match_data.forEach((item, index) => {
                                _this.imgUpload('matchImg-' + index, index)
                            })
                        }
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

		// 清除所有上传实例
		clearAllUploaders() {
			if (this.singleUploaders.length > 0) {
				this.singleUploaders.forEach(item => {
					item.destroy()
				})
				this.singleUploaders = []
			}
			if (this.chatUploaders.length > 0) {
				this.chatUploaders.forEach(item => {
					item.destroy()
				})
				this.chatUploaders = []
			}
			if (this.bottomUploaders.length > 0) {
				this.bottomUploaders.forEach(item => {
					item.destroy()
				})
				this.bottomUploaders = []
			}
			if (this.topUploaders.length > 0) {
				this.topUploaders.forEach(item => {
					item.destroy()
				})
				this.topUploaders = []
			}
			if (this.screenUploaders.length > 0) {
				this.screenUploaders.forEach(item => {
					item.destroy()
				})
				this.screenUploaders = []
			}
			if (this.matchUploaders.length > 0) {
				this.matchUploaders.forEach(item => {
					item.destroy()
				})
				this.matchUploaders = []
			}
		},

			// 上传图片
			imgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';
				let resize_width = 400,
					resize_height = 400;
				if (id.indexOf('singleImg-') > -1) { // 互动广场 单屏模式	
					resize_width = 527
					resize_height = 296
				} else if (id.indexOf('chatImg-') > -1) { // 互动广场 四联屏聊天
					resize_width = 648
					resize_height = 240
				} else if (id.indexOf('bottomImg-') > -1) { // 互动广场 四联屏底部
					resize_width = 880
					resize_height = 210
				} else if (id.indexOf('topImg-') > -1) { // 语音点歌 四联屏-互动屏顶部
					resize_width = 880
					resize_height = 210
				} else if (id.indexOf('screenImg-') > -1) { // 电视屏保 四联屏-互动屏 屏保
					resize_width = 1080
					resize_height = 1920
				} else if (id.indexOf('matchImg-') > -1) { // 电视屏保 四联屏-互动屏 屏保
					resize_width = 1080
					resize_height = 1920
				}

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "png" }
							],
							// max_file_size: '2mb', // 文件大小限制
							prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: resize_width,
							height: resize_height
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'Setting'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								if (id.indexOf('singleImg-') > -1) { // 上传互动广场单屏模式图片
									_this.jhPlazaAd.imgs[index] = host + "/" + dir + file_name
								}else if(id.indexOf('chatImg-') > -1) { // 四联屏聊天
									_this.jhPlazaAd.multiple_screens_chat_imgs[index] = host + "/" + dir + file_name
								}else if(id.indexOf('bottomImg-') > -1) { // 四联屏底部
									_this.jhPlazaAd.multiple_screens_bottom_imgs[index] = host + "/" + dir + file_name
								}else if (id == 'changeAvatarBtn') { // 上传虚拟头像
									console.log(host + "/" + dir + file_name)
									_this.jhPlazaAd.virtual_user_img = host + "/" + dir + file_name
								}else if(id.indexOf('topImg-') > -1) { // 四联屏-互动屏顶部
									_this.chooseSongAd.multiple_screens_top_imgs[index] = host + "/" + dir + file_name
								}else if(id.indexOf('screenImg-') > -1) { // 四联屏-互动屏 屏保
									_this.screenSaverAd.multiple_screens_imgs[index] = host + "/" + dir + file_name
								}else if(id.indexOf('matchImg-') > -1) { // 电视屏保 四联屏-互动屏 屏保
									_this.screenSaverAd.match_data[index].img = host + "/" + dir + file_name
								}
								_this.$forceUpdate() // 强制更新视图
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传png文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
					if (id.indexOf('singleImg-') > -1) {
						_this.singleUploaders.push(uploader)
					}else if(id.indexOf('chatImg-') > -1) {
						_this.chatUploaders.push(uploader)
					}else if(id.indexOf('bottomImg-') > -1) {
						_this.bottomUploaders.push(uploader)
					}else if (id == 'changeAvatarBtn') {
						_this.avatarUploaders.push(uploader)
					}else if(id.indexOf('topImg-') > -1) {
						_this.topUploaders.push(uploader)
					}else if(id.indexOf('screenImg-') > -1) {
						_this.screenUploaders.push(uploader)
					}else if(id.indexOf('matchImg-') > -1) {
						_this.matchUploaders.push(uploader)
					}
				}, 20);
			},

			// 新增图片
			onAddImgClick(type) {
				if (type == 'single') { // 单屏模式
					if (this.jhPlazaAd.imgs.length > 9) {
						layer.msg('最多可设置10张')
						return
					}
					this.jhPlazaAd.imgs.push('')
					this.imgUpload('singleImg-' + (this.jhPlazaAd.imgs.length - 1), this.jhPlazaAd.imgs.length -1)
				}else if (type == 'chat') { // 四联屏聊天
					if (this.jhPlazaAd.multiple_screens_chat_imgs.length > 9) {
						layer.msg('最多可设置10张')
						return
					}
					this.jhPlazaAd.multiple_screens_chat_imgs.push('')
					this.imgUpload('chatImg-' + (this.jhPlazaAd.multiple_screens_chat_imgs.length - 1), this.jhPlazaAd.multiple_screens_chat_imgs.length -1)
				}else if (type == 'bottom') { // 四联屏底部
					if (this.jhPlazaAd.multiple_screens_bottom_imgs.length > 9) {
						layer.msg('最多可设置10张')
						return
					}
					this.jhPlazaAd.multiple_screens_bottom_imgs.push('')
					this.imgUpload('bottomImg-' + (this.jhPlazaAd.multiple_screens_bottom_imgs.length - 1), this.jhPlazaAd.multiple_screens_bottom_imgs.length -1)
				}else if (type == 'top') { // 四联屏-互动屏顶部
					if (this.chooseSongAd.multiple_screens_top_imgs.length > 9) {
						layer.msg('最多可设置10张')
						return
					}
					this.chooseSongAd.multiple_screens_top_imgs.push('')
					this.imgUpload('topImg-' + (this.chooseSongAd.multiple_screens_top_imgs.length - 1), this.chooseSongAd.multiple_screens_top_imgs.length -1)
				}else if (type == 'screen') { // 四联屏-互动屏 屏保
					if (this.screenSaverAd.multiple_screens_imgs.length > 9) {
						layer.msg('最多可设置10张')
						return
					}
					this.screenSaverAd.multiple_screens_imgs.push('')
					this.imgUpload('screenImg-' + (this.screenSaverAd.multiple_screens_imgs.length - 1), this.screenSaverAd.multiple_screens_imgs.length -1)
				}
			},

			// 删除图片
			delThisImg(type, index) {
				if (type == 'single') { // 单屏模式
					this.jhPlazaAd.imgs.splice(index, 1)
					this.singleUploaders[index].destroy()
					this.singleUploaders.splice(index, 1)
				}else if (type == 'chat') { // 四联屏聊天
					this.jhPlazaAd.multiple_screens_chat_imgs.splice(index, 1)
					this.chatUploaders[index].destroy()
					this.chatUploaders.splice(index, 1)
				}else if (type == 'bottom') { // 四联屏底部
					this.jhPlazaAd.multiple_screens_bottom_imgs.splice(index, 1)
					this.bottomUploaders[index].destroy()
					this.bottomUploaders.splice(index, 1)
				}else if (type == 'top') { // 四联屏-互动屏顶部
					this.chooseSongAd.multiple_screens_top_imgs.splice(index, 1)
					this.topUploaders[index].destroy()
					this.topUploaders.splice(index, 1)
				}else if (type == 'screen') { // 四联屏-互动屏 屏保
					this.screenSaverAd.multiple_screens_imgs.splice(index, 1)
					this.screenUploaders[index].destroy()
					this.screenUploaders.splice(index, 1)
				}
			},

			// 打开头像设置弹窗
			openAvatarPop() {
				let _this = this;

				if (this.avatarUploaders.length > 0) {
					this.avatarUploaders.forEach(item => {
						item.destroy()
					})
					this.avatarUploaders = []
				}

				let c_avatar = _this.jhPlazaAd.virtual_user_img
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['聊天任务头像及昵称设置', true],
					area: ['500px', '500px'],
					content: $(_this.$refs.avatar_set_pop),
					offset: '100px',
					cancel: function() {
						_this.jhPlazaAd.virtual_user_img = c_avatar
					}
				}, function() {
					layer.closeAll()
				}, function() {
					_this.jhPlazaAd.virtual_user_img = c_avatar
				});

				this.$nextTick(() => {
					this.imgUpload('changeAvatarBtn')
				})
			},

			backList() {
				this.showList = true
				this.showHdgc = false
				this.showYydg = false
				this.showDspb = false
			},

			fillterEmptyImg(type, obj) {
				let form = JSON.parse(JSON.stringify(obj))
				if (type == 'jhPlazaAd') {
					if (form.imgs.length > 1) {
						form.imgs.forEach((item, index) => {
							if (item == '') {
								form.imgs.splice(index, 1)
							}
						})
					}
					if (form.multiple_screens_chat_imgs.length > 1) {
						form.multiple_screens_chat_imgs.forEach((item, index) => {
							if (item == '') {
								form.multiple_screens_chat_imgs.splice(index, 1)
							}
						})
					}
					if (form.multiple_screens_bottom_imgs.length > 1) {
						form.multiple_screens_bottom_imgs.forEach((item, index) => {
							if (item == '') {
								form.multiple_screens_bottom_imgs.splice(index, 1)
							}
						})
					}
				}else if (type == 'chooseSongAd') {
					if (form.multiple_screens_top_imgs.length > 1) {
						form.multiple_screens_top_imgs.forEach((item, index) => {
							if (item == '') {
								form.multiple_screens_top_imgs.splice(index, 1)
							}
						})
					}
				}else if (type == 'screenSaverAd') {
					if (form.multiple_screens_imgs.length > 1) {
						form.multiple_screens_imgs.forEach((item, index) => {
							if (item == '') {
								form.multiple_screens_imgs.splice(index, 1)
							}
						})
					}
				}
				console.log(form)
				return form				
			},

			// 提交互动广场设置
			submitHdgc() {
				const _this = this;

				Vue.axios.post('JhPlazaAd/editData', {
					"header": Vue.request_header,
					"request": {
						"param": _this.fillterEmptyImg('jhPlazaAd', _this.jhPlazaAd)
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg("保存成功！")
						_this.backList()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 提交语音点歌设置
			submitYydg() {
				const _this = this;

				Vue.axios.post('ScreenAd/setVoiceChooseSongAd', {
					"header": Vue.request_header,
					"request": {
						"param": _this.fillterEmptyImg('chooseSongAd', _this.chooseSongAd)
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg("保存成功！")
						_this.backList()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 提交电视屏保设置
			submitDspb() {
				const _this = this;

				Vue.axios.post('ScreenAd/setScreensaverAd', {
					"header": Vue.request_header,
					"request": {
						"param": _this.fillterEmptyImg('screenSaverAd', _this.screenSaverAd)
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg("保存成功！")
						_this.backList()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 添加榜单项
			addRankItem() {
				if (this.screenSaverAd.match_data.length >= 10) {
					layer.msg('最多只能添加10个榜单');
					return;
				}
				
				this.screenSaverAd.match_data.push({
                    id: '',
                    match: '1',
                    group: '1',
                    cycle: '1',
                    img: ''
				});
                this.imgUpload('matchImg-' + (this.screenSaverAd.match_data.length - 1), this.screenSaverAd.match_data.length -1)
			},

			// 删除榜单项
			removeRankItem(index) {
				this.screenSaverAd.match_data.splice(index, 1);
                this.matchUploaders[index].destroy()
                this.matchUploaders.splice(index, 1)
			},

            // 同步数据
            syncData() {
                if (!this.shop_id) {
                    layer.msg('请先选择门店');
                    return;
                }
                
                // 重置选择状态
                this.selectAll = false;
                this.selectedShops = [];
                
                // 打开同步弹窗
                layer.open({
                    type: 1,
                    title: '同步提示',
                    skin: 'public-alert-skin',
					area: ['600px', '600px'],
                    content: $(this.$refs.sync_pop),
                });
            },

            // 全选/反全选
            handleSelectAll(checked) {
                if (checked) {
                    // 全选：将所有其他门店的id加入数组
                    this.selectedShops = this.shop_list
                        .filter(shop => shop.id != this.shop_id)
                        .map(shop => shop.id);
                } else {
                    // 反全选：清空数组
                    this.selectedShops = [];
                }
            },

            // 取消同步
            cancelSync() {
                layer.closeAll();
            },

            // 确认同步
            confirmSync() {
                if (this.selectedShops.length === 0) {
                    layer.msg('请选择要同步的门店');
                    return;
                }

                const _this = this;
                layer.confirm('确认要将当前门店的电视屏广告设置同步到选中的门店吗？', {
                    btn: ['确定', '取消'],
                    title: '确认同步'
                }, function() {
                    _this.doSync();
                });
            },

            // 执行同步
            doSync() {
                const _this = this;
                
                // 显示loading遮罩层
                const loadingIndex = layer.load(1, {
                    shade: [0.3, '#000'] // 0.3透明度的黑色背景
                });
                
                Vue.axios.post('ScreenAd/batchSetAd', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "origin_shop_id": _this.shop_id,
                            "shop_ids": _this.selectedShops
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.close(loadingIndex); // 关闭loading
                    if(res.data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg('同步成功！');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.close(loadingIndex); // 关闭loading
                    layer.msg('同步失败，请重试');
                });
            }

		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    p {
        color: #FF0707;
    }
    .adsc-list {
        h1 {
            margin: 20px 0;
            text-align: center;
        }
    }

    .red-tip {
    	color: red;
    }

	.hdgc-panel,
	.yydg-panel,
	.dspb-panel {
	    h4 {
	    	margin: 20px 0;
	    }	
	}

	.gray-block {
		width: 1000px;
		background: #efefef;
		padding: 20px 10px;
		.row {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 20px;
			.label {
				color: #444;
				font-size: 14px;
				&.big {
					font-size: 18px;
				}
			}
			.el-input {
				width: 280px;
				margin-right: 10px;
			}
		}
		.imgs-wrapper {
			padding-top: 10px;
			display: flex;
			flex-direction: row;
			align-items: center;
			flex-wrap: wrap;
			.item {
				position: relative;
				margin: 0 30px 30px 0;
				cursor: pointer;
				&.single {
					width: 180px;
					height: 101px;
				}
				&.chat {
					width: 216px;
					height: 80px;
				}
				&.bottom {
					width: 220px;
					height: 52px;
				}
				&.screen {
					width: 108px;
					height: 192px;
				}
				.img {
					width: 100%;
					height: 100%;
					background: #fff;
				}
				.del-icon {
					position: absolute;
					top: -10px;
					right: -10px;
					width: 24px; 
				}
			}
		}
        .ranks-wrapper{
            margin-top: 20px;
            
            .ranks-container {
                display: flex;
                overflow-x: auto;
                gap: 20px;
                padding: 10px 0;
                scroll-behavior: smooth;
                
                /* 自定义滚动条样式 */
                &::-webkit-scrollbar {
                    height: 8px;
                }
                
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                    
                    &:hover {
                        background: #a8a8a8;
                    }
                }
                
                /* Firefox滚动条样式 */
                scrollbar-width: thin;
                scrollbar-color: #c1c1c1 #f1f1f1;
            }
            
            .rank-item {
                position: relative;
                min-width: 320px;
                max-width: 320px;
                background: #f8f9fa;
                border: 1px solid #e9ecef;
                border-radius: 8px;
                padding: 15px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                flex-shrink: 0;
                
                .rank-content {
                    display: flex;
                    gap: 15px;
                }
                
                .image-section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    
                    .image-placeholder {
                        width: 110px;
                        height: 150px;
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #fff;
                        position: relative;
                        overflow: hidden;
                        
                        .background-img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }

                        .change-btn {
                            position: absolute;
                            bottom: 10px;
                        }
                    }
                }
                
                .dropdowns-section {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    flex: 1;
                    
                    .rank-dropdown {
                        .el-input__inner {
                            font-size: 12px;
                            padding: 8px 12px;
                        }
                    }
                }
                
                .close-btn {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    width: 20px;
                    height: 20px;
                    background: #dc3545;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    color: white;
                    font-size: 12px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    
                    &:hover {
                        background: #c82333;
                    }
                }
            }
            
            .add-rank-item {
                min-width: 320px;
                max-width: 320px;
                height: 140px;
                border: 2px dashed #dee2e6;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s ease;
                flex-shrink: 0;
                
                &:hover {
                    border-color: #007bff;
                    background: #f8f9ff;
                }
                
                .add-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 8px;
                    color: #6c757d;
                    
                    i {
                        font-size: 24px;
                    }
                    
                    span {
                        font-size: 14px;
                    }
                }
            }
            
            /* 响应式设计 */
            @media (max-width: 768px) {
                .ranks-container {
                    gap: 15px;
                    padding: 8px 0;
                }
                
                .rank-item {
                    min-width: 280px;
                    max-width: 280px;
                    padding: 12px;
                }
                
                .add-rank-item {
                    min-width: 280px;
                    max-width: 280px;
                    height: 120px;
                }
                
                .image-section .image-placeholder {
                    width: 100px;
                    height: 70px;
                }
            }
        }
	}

	.btns {
		margin-top: 30px;
	}

	.avatar-set-pop {
		.el-input {
			width: 300px;
		}
		.avatar-wrapper {
			width: 300px;
			display: flex;
			flex-direction: column;
			align-items: center;
			.avatar-img {
				margin: 20px;
				width: 100px;
				height: 100px;
				border-radius: 50%;
				overflow: hidden;
			}
		}
	}

	// 同步弹窗样式
	.sync-pop {
		.sync-content {
			padding: 20px;
			
			.sync-title {
				color: #FF0707;
				font-size: 16px;
				font-weight: bold;
				margin-bottom: 10px;
				text-align: center;
			}
			
			.sync-subtitle {
				color: #333;
				font-size: 14px;
				margin-bottom: 20px;
				text-align: center;
			}
			
			.shop-list {
				background: #fff;
				border: 1px solid #ddd;
				border-radius: 4px;
				padding: 15px;
				margin-bottom: 20px;
				max-height: 300px;
				overflow-y: auto;
				
				.shop-item {
					margin-bottom: 10px;
					
					&:last-child {
						margin-bottom: 0;
					}
				}
				
				.shop-grid {
					display: grid;
					grid-template-columns: repeat(3, 1fr);
					gap: 10px;
					margin-top: 10px;
					
					.shop-item {
						margin-bottom: 0;
					}
				}
			}
			
			.sync-buttons {
				text-align: center;
				
				.el-button {
					margin: 0 10px;
					min-width: 80px;
				}
			}
		}
	}
</style>